import { render, staticRenderFns } from "./SupplierNotificationsView.vue?vue&type=template&id=81b55ff6&"
import script from "./SupplierNotificationsView.vue?vue&type=script&lang=js&"
export * from "./SupplierNotificationsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports